import { Role, User } from 'models/User';

export default {
  checkRoleForUser(user: User, roles: Role[]) {
    return roles.includes(user.role);
  },
};
